import { useEffect, useState } from 'react';
import { useCustomer } from './useCustomer';
import { useLocation } from 'react-router-dom';

export default function useNewsletterSubscribe(): {
  initialValues: IniatialValuesType;
} {
  const { customer } = useCustomer();
  const [initialValues, setInitialValues] = useState<IniatialValuesType>(
    defaultValues
  );
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    if (state) {
      initialValues.email = state.emailValue;
      initialValues.mailOption = state.mailOption;
      initialValues.partOption = state.partOption;
      initialValues.smsOption = state.smsOption;
    }

    if (customer?.isLoggedIn) {
      const {
        email,
        civility,
        firstName,
        lastName,
        cellPhone,
        dateOfBirth,
      } = customer;
      setInitialValues({
        ...initialValues,
        email: email,
        civility: civility,
        firstName: firstName,
        lastName: lastName,
        ...(cellPhone && { cellPhone: cellPhone }),
        dateOfBirth: dateOfBirth,
      });
    }
  }, [customer]);

  return {
    initialValues,
  };
}

const defaultValues = {
  turnstileToken: '',
  email: '',
  civility: '',
  lastName: '',
  firstName: '',
  cellPhone: '',
  dateOfBirth: '',
  mailOption: '1',
  smsOption: '',
  partOption: '',
};

export type IniatialValuesType = {
  turnstileToken: string;
  email: string;
  civility: string;
  lastName: string;
  firstName: string;
  cellPhone: string;
  dateOfBirth?: string;
  mailOption: string;
  smsOption: string;
  partOption: string;
};
